import * as React from 'react';
import cn from 'clsx';
import { useDeviceType, ArticleParagraph1, InformationTooltip, UIHeading4, Button, UIText2 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';

import { IBankInfoModalContent } from 'shared/mortgageMiniCalculator/types/modal';
import { PskTooltipContent } from 'shared/mortgageMiniCalculator/components/PskTooltipContent';

import styles from './styles.css';
import { Layout } from '../Layout';
import { ETestIds } from '../../../../constants';
import { useTracking } from 'shared/mortgageMiniCalculator/utils/tracking/useTracking';
import { useSelector } from 'react-redux';
import { selectOfferForAnalytic } from '../../../../selectors/analytic/selectOfferForAnalytic';
import { useAuthAction } from '../../../../hooks/useAuthAction';
import { NBSP } from 'shared/common/constants';

interface IBankInfoModalContentProps {
  creditInfo: IBankInfoModalContent;
  redirectUrl: string;
}

export const BankInfoModalContent: React.FC<IBankInfoModalContentProps> = ({ creditInfo, redirectUrl }) => {
  const deviceType = useDeviceType();
  const { offerName, offerDescription, iconPath, rows, button } = creditInfo;
  const offerForAnalytic = useSelector(selectOfferForAnalytic);
  const { trackClickOnCreateMortgage } = useTracking();
  const { isLoading, handleAuthAction } = useAuthAction({
    trackingFunction: () => trackClickOnCreateMortgage(offerForAnalytic),
    redirectUrl,
  });

  return (
    <Layout
      headerName={offerName}
      headerDescription={offerDescription}
      headerLogoUrl={iconPath}
      testId={ETestIds.BankModal}
      content={
        <>
          <UIHeading4>Все условия кредита</UIHeading4>
          <ul className={cn(styles['list'], styles[deviceType])}>
            {rows.map((el, index) => {
              return (
                <li key={index} className={cn(styles['item'], styles[deviceType])}>
                  <ArticleParagraph1 color="text-secondary-default">
                    {el.key}
                    {el.tooltip && (
                      <InformationTooltip placement={'right-start'} content={<PskTooltipContent />} header={el.tooltip}>
                        <span className={styles['tooltip-icon']}>
                          <IconFunctionalInformationCircle16 />
                        </span>
                      </InformationTooltip>
                    )}
                  </ArticleParagraph1>
                  {/* eslint-disable-next-line react/no-danger */}
                  <div className={styles['value']} dangerouslySetInnerHTML={{ __html: el.value }} />
                </li>
              );
            })}
          </ul>
        </>
      }
      button={
        <div className={cn(styles['button'], styles[deviceType])}>
          <Button onClick={handleAuthAction} loading={isLoading} disabled={isLoading} data-testid={ETestIds.BankButton}>
            {button.text}
          </Button>
          <div className={cn(styles['text-wrapper'], styles[deviceType])}>
            <UIText2 color={'text-secondary-default'}>{`Заявка${NBSP}— единая для всех банков. Не оферта.`}</UIText2>
            <UIText2 color={'text-secondary-default'}>{`Перед${NBSP}заполнением попросим авторизоваться.`}</UIText2>
          </div>
        </div>
      }
    />
  );
};
